export default __webpack_public_path__ + "static/media/truck-front.092b99c6.png";